import React, { PureComponent } from "react";

import Select from "react-select";

import { Accordion, Button, ButtonGroup, Dropdown, Icon } from "aible";

import styles from "./style.module.css";

export default class ProjectHelp extends React.PureComponent {
  render() {
    const {
      title,
      subtitle,
      children,
      onToggle,
      hide,
      isDark,
      stepId,
      className,
      noBot,
      isHelpOpen,
      updateIsHelpOpen,
      ...retProps
    } = this.props;
    return (
      <div className={styles.projectHelpWrapper}>
        <Accordion
          onToggle={() => {
            updateIsHelpOpen();
            return onToggle ? onToggle() : undefined;
          }}
          header={<div className={styles.projectHelpTitle}>{title}</div>}
          show={isHelpOpen}
          shrinkHeader
          noBot={noBot}
        >
          <div className={styles.projectHelp + " " + (className ? className : "")} {...retProps}>
            <div className={styles.projectHelpSubtitle + " " + (isDark ? styles.isDark : "")} title={subtitle}>
              {subtitle}
            </div>
            <div className={styles.projectHelpContent}>{children}</div>
          </div>
        </Accordion>
      </div>
    );
  }
}
